export class ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotLocation",
            "baseName": "snapshotLocation",
            "type": "SnapshotLocation",
            "format": ""
        },
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConvertOtherSnapshotsOnDemandRequestSnapshotDetailsInner.attributeTypeMap;
    }
    constructor() {
    }
}
